import { produce } from 'immer';

import { BREADCRUMB_PREFERRED_ALIAS_SET, BREADCRUMB_PREFERRED_ALIAS_CLEAR } from './breadcrumbNavigationConstants';
import type { BreadcrumbNavigationAction } from './breadcrumbNavigationActions';

export type BreadcrumbNavigationState = {
    preferredAliasIdByBoardId: Record<string, string>;
};

const initialState: BreadcrumbNavigationState = {
    preferredAliasIdByBoardId: {},
};

const breadcrumbNavigationReducer = (
    state = initialState,
    action: BreadcrumbNavigationAction,
): BreadcrumbNavigationState => {
    switch (action.type) {
        case BREADCRUMB_PREFERRED_ALIAS_SET:
            return produce(state, (draft) => {
                draft.preferredAliasIdByBoardId[action.boardId] = action.aliasId;
            });

        case BREADCRUMB_PREFERRED_ALIAS_CLEAR:
            return produce(state, (draft) => {
                delete draft.preferredAliasIdByBoardId[action.boardId];
            });

        default:
            return state;
    }
};

export default breadcrumbNavigationReducer;
